import { NamedProperty } from "sprint-common-web";

export const TRAILER_VERSION_TYPE_ID = "00000000-0000-0000-0000-000000000001";

export const TRAILER_VERSION_TYPE = {
    id: TRAILER_VERSION_TYPE_ID,
    name: "Trailer"
} as const;

export type TrailerVersionType = typeof TRAILER_VERSION_TYPE;

export const isTrailerVersionType = (version?: NamedProperty): version is TrailerVersionType =>
    version?.id === TRAILER_VERSION_TYPE.id;
